export default{
    
    lista:{
        method:'get',
        url:'cessao/trabalhador/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'cessao/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'cessao/trabalhador/deletar{/id}'
    },
    deleteremoneracaoempresa:{
        method:'delete',
        url:'cessao/remoneracao/empresa/trabalhador/deletar{/id}'
    },
    deletevalorcalculo:{
        method:'delete',
        url:'cessao/valor/calculo/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'cessao/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'cessao/trabalhador/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    },
    update2231:{
        method:'put',
        url:'cessao/trabalhador/2231/update'
    },
    cadastra2231:{
        method:'post',
        url:'cessao/trabalhador/2231/cadastro'
    },
    delete2231:{
        method:'delete',
        url:'cessao/trabalhador/2231/deletar{/id}'
    },
}